import React from 'react';
import { Dialog, DialogContent, DialogClose, DialogTitle } from '@/components/ui/dialog';
import { PortfolioItem } from '@/hooks/useProfile';
import PortfolioModalContent from './portfolio/modal/PortfolioModalContent';
import { useIsMobile } from '@/hooks/use-mobile';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

interface PortfolioItemModalProps {
  item: PortfolioItem;
  isOpen: boolean;
  onClose: () => void;
  username: string;
  username_slug: string;
}

const PortfolioItemModal = ({ 
  item, 
  isOpen, 
  onClose, 
  username,
  username_slug
}: PortfolioItemModalProps) => {
  const isMobile = useIsMobile();

  return (
    <Dialog open={isOpen} onOpenChange={() => onClose()}>      
      <DialogContent aria-describedby={undefined} className="h-full flex flex-col justify-center items-center py-4 md:py-0 px-2 md:px-4 max-w-none bg-white/20 backdrop-blur-md border-none shadow-none">
        <DialogTitle className="sr-only">{item.title}</DialogTitle>
        <div className=''>
          <DialogClose className="flex items-center justify-center w-10 h-10 rounded-full bg-white shadow-md hover:bg-gray-50 transition-colors">
            <X size={16} className="text-gray-500" />
            <span className="sr-only">Close</span>
          </DialogClose>
        </div>
        <PortfolioModalContent 
          item={item}
          onClose={onClose}
          username={username}
          username_slug={username_slug}
        />
      </DialogContent>
    </Dialog>
  );
};

export default PortfolioItemModal;
